/** Photo-condition tier colours: the bar segment and the chip
 *  (PhotoIntelCard, PhotoLightbox). Its own module so the lightbox,
 *  which the listing drawer opens, does not pull in the whole photo
 *  analysis card (2026-10-19). */
//
// A calm good-to-worn scale (owner, 2026-10-30: the five pastel colours
// and the sky-blue "Orta" read loud): the two good tiers in emerald, the
// average in grey, dated in amber, a bare shell in rose. Colour still
// means something here, never decoration.
export const TIER_STYLE: Record<string, { seg: string; chip: string }> = {
  luxury: { seg: "bg-emerald-600", chip: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  modern: { seg: "bg-emerald-400", chip: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  mid:    { seg: "bg-gray-400", chip: "bg-gray-100 text-gray-700 border-gray-200" },
  dated:  { seg: "bg-amber-400", chip: "bg-amber-50 text-amber-700 border-amber-200" },
  shell:  { seg: "bg-rose-400", chip: "bg-rose-50 text-rose-700 border-rose-200" },
};
